import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Search, X } from "lucide-react";

export function SearchFilterBar({ search, onSearchChange, filters = [], onClear }) {
  const hasFilters = search || filters.some((f) => f.value);

  return (
    <div className="bg-white border border-[#E2E8F0] p-4 flex flex-wrap gap-3 items-end" data-testid="search-filter-bar">
      <div className="flex-1 min-w-[200px]">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
          <Input
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search..."
            className="pl-9 rounded-none border-[#E2E8F0] text-sm"
            data-testid="search-input"
          />
        </div>
      </div>
      {filters.map((filter) => (
        <div key={filter.key} className="w-44">
          <Select value={filter.value || "all"} onValueChange={(v) => filter.onChange(v === "all" ? "" : v)}>
            <SelectTrigger className="rounded-none border-[#E2E8F0] text-sm" data-testid={`filter-${filter.key}`}>
              <SelectValue placeholder={filter.placeholder} />
            </SelectTrigger>
            <SelectContent className="bg-white rounded-none border border-[#E2E8F0]">
              <SelectItem value="all">All {filter.placeholder}</SelectItem>
              {filter.options.map((opt) => (
                <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      ))}
      {hasFilters && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onClear}
          className="text-[#64748B] hover:text-[#DC2626]"
          data-testid="clear-filters-button"
        >
          <X size={14} className="mr-1" /> Clear
        </Button>
      )}
    </div>
  );
}
